module.exports = __webpack_public_path__ + "img/ax_cake.a7ccfef2.png";